import React from 'react';

import {
  applyOptimisticCompletions,
  markCompletionConfirmed,
  markCompletionPending,
  reconcileConfirmedCompletions,
  removeOptimisticCompletion,
} from '../optimisticEventCompletion';

export function useOptimisticEventCompletion(sourceEvents) {
  const [completionState, setCompletionState] = React.useState({});

  const events = React.useMemo(
    () => applyOptimisticCompletions(sourceEvents, completionState),
    [completionState, sourceEvents]
  );

  const startCompletion = React.useCallback((eventId) => {
    setCompletionState((current) => markCompletionPending(current, eventId));
  }, []);

  const confirmCompletion = React.useCallback((eventId) => {
    setCompletionState((current) => markCompletionConfirmed(current, eventId));
  }, []);

  const rollbackCompletion = React.useCallback((eventId) => {
    setCompletionState((current) => removeOptimisticCompletion(current, eventId));
  }, []);

  const reconcileCompletions = React.useCallback(() => {
    setCompletionState(reconcileConfirmedCompletions);
  }, []);

  const resetCompletions = React.useCallback(() => {
    setCompletionState((current) => (Object.keys(current).length === 0 ? current : {}));
  }, []);

  return {
    confirmCompletion,
    events,
    reconcileConfirmedCompletions: reconcileCompletions,
    resetCompletions,
    rollbackCompletion,
    startCompletion,
  };
}
